import { ErrorHandler, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { HeimdallErrorHandler } from './heimdall-error-handler';

export function provideErrorTracking(): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: ErrorHandler, useClass: HeimdallErrorHandler }]);
}
